
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui'

interface ErrorPageProps {
    code: string | number
    title: string
    description: string
    actionLabel?: string
    onAction?: () => void
    showHomeButton?: boolean
}

export function ErrorPage({
    code,
    title,
    description,
    actionLabel,
    onAction,
    showHomeButton = true,
}: ErrorPageProps) {
    const navigate = useNavigate()

    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-slate-950 p-4 text-center">
            <div className="relative mb-8">
                <h1 className="text-[150px] font-bold leading-none text-slate-900 blur-sm md:text-[200px]">
                    {code}
                </h1>
                <div className="absolute inset-0 flex items-center justify-center">
                    <span className="bg-gradient-to-r from-sky-400 to-blue-600 bg-clip-text text-6xl font-bold text-transparent md:text-8xl">
                        {code}
                    </span>
                </div>
            </div>

            <h2 className="mb-4 text-2xl font-bold text-slate-100 md:text-3xl">{title}</h2>
            <p className="mb-8 max-w-md text-slate-400">{description}</p>

            <div className="flex flex-col gap-4 sm:flex-row">
                {onAction && actionLabel && (
                    <Button onClick={onAction} variant="primary" size="lg">
                        {actionLabel}
                    </Button>
                )}
                {showHomeButton && (
                    <Button onClick={() => navigate('/')} variant="outline" size="lg">
                        Return Home
                    </Button>
                )}
            </div>
        </div>
    )
}
